var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"section-1"},[_c('h1',[_vm._v("Fälle (Beta)")]),_c('div',[_c('FullHierarchySearch',{attrs:{"type":"cases"}})],1)]),_c('HomeContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }